 const mensTeesData = [
    {
      id: 1,
      image: "https://images.unsplash.com/photo-1617137968427-85924c800a22?w=800",
      title: "Earth Brown Flex Tee",
      oldPrice: 1799,
      price: 1499
    },
    {
      id: 2,
      image: "https://images.unsplash.com/photo-1515886657613-9f3515b0c78f?w=800",
      title: "Evergreen Flex Tee",
      oldPrice: 1799,
      price: 1499
    },
    {
      id: 3,
      image: "https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=800",
      title: "Onyx Gym Flex Tee",
      oldPrice: 1799,
      price: 1499
    },
    {
      id: 4,
      image: "https://images.unsplash.com/photo-1503342217505-b0a15ec3261c?w=800",
      title: "Combo Offer Flex Tees",
      oldPrice: 2999,
      price: 2499
    },
    {
      id: 5,
      image: "https://images.unsplash.com/photo-1504593811423-6dd665756598?w=800",
      title: "Armour Compression Navy",
      oldPrice: 1799,
      price: 1499
    },
    {
      id: 6,
      image: "https://images.unsplash.com/photo-1483985988355-763728e1935b?w=800",
      title: "Armour Compression White",
      oldPrice: 1799,
      price: 1499
    },
    {
      id: 7,
      image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=800",
      title: "Compression Grey Tee",
      oldPrice: 1799,
      price: 1499
    },
    {
      id: 8,
      image: "https://images.unsplash.com/photo-1618886614638-80e3c103d31a?w=800",
      title: "Compression Black Tee",
      oldPrice: 1799,
      price: 1499
    },
    {
      id: 9,
      image: "https://images.unsplash.com/photo-1517841905240-472988babdf9?w=800",
      title: "Olive Gym Tee",
      oldPrice: 999,
      price: 699
    },
    {
      id: 10,
      image: "https://images.unsplash.com/photo-1523398002811-999ca8dec234?w=800",
      title: "Ultimate Armour Tee",
      oldPrice: 999,
      price: 799
    },
    {
      id: 11,
      image: "https://images.unsplash.com/photo-1496747611176-843222e1e57c?w=800",
      title: "Air Gym Tech Tee",
      oldPrice: 899,
      price: 699
    },
    {
      id: 12,
      image: "https://images.unsplash.com/photo-1512436991641-6745cdb1723f?w=800",
      title: "Air Gym Tech V2",
      oldPrice: 899,
      price: 699
    }
  ];
  export default mensTeesData;